<template>
  <div class="drawer-search-table-package-text">
    <el-button type="text" @click="handleClick" class="package_text">{{ value }}</el-button>
    <PgDrawerSearchTable
      v-if="open"
      v-bind="$attrs"
      v-on="$listeners"
      @close="close"
    ></PgDrawerSearchTable>
  </div>
</template>
<script setup>
// vue
import { ref } from 'vue'
defineProps({
  // 侧滑放入body中
  value: {
    type: String,
    default: '',
  },
})

const open = ref(false)

const handleClick = () => {
  open.value = true
}

const close = () => {
  open.value = false
}
</script>
<style lang="scss">
@import '../style/drawer-search-table-package-text.scss';
</style>
